<template>
  <div class="app-container" id="xmcheck">
    <el-button
      type="primary"
      plain
      size="small"
      icon="el-icon-back"
      @click="toTaskList()"
      style="margin-left: 10px; height: 32px; margin-right: 15px"
      >返回</el-button
    >

    <el-radio-group
      v-model="queryParams.type"
      @change="handleClick"
      style="margin-top: -2px"
    >
      <el-radio border size="small" :label="0" class="myRadio">我奖励</el-radio>
      <el-radio border size="small" :label="1" class="myRadio"
        >待我奖励</el-radio
      >
      <el-radio border size="small" :label="2" class="myRadio"
        >我已奖励</el-radio
      >
    </el-radio-group>
    <div class="mycontainer" style="margin-bottom: 10px">
      <el-form ref="queryForm" :model="queryParams" :inline="true">
        <el-form-item label="认领人">
          <el-select
            v-model="queryParams.rlrquery"
            placeholder="认领人"
            multiple
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in rlrList"
              :key="item.ygbh"
              :label="item.xm"
              :value="item.ygbh"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="协作人">
          <el-select
            v-model="queryParams.xzrquery"
            placeholder="协作人"
            multiple
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in xzrList"
              :key="item.ygbh"
              :label="item.xm"
              :value="item.ygbh"
            ></el-option>
          </el-select>
        </el-form-item>
        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="handleQuery"
            >查询</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-download"
            size="small"
            @click="handleExport"
            >导出</el-button
          >
        </span>
      </el-form>
    </div>

    <div>
      <el-table
        v-loading="loading"
        :data="reward"
        fit
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :max-height="height"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          fixed
          label="操作"
          min-width="150"
          align="center"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              @click="handleUpdate(scope.row.rlId)"
              >奖励</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="认领人"
          prop="rlr"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          align="center"
          label="协作人"
          prop="xzr"
          min-width="150px"
          :show-overflow-tooltip="true"
        />

        <el-table-column
          label="任务编号"
          align="center"
          prop="rwbh"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="任务所属条线"
          prop="txlx"
          align="center"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="任务所属部门"
          prop="bmbh"
          align="center"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          align="center"
          label="任务类型"
          prop="rwlx"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          align="center"
          label="子类"
          prop="zl"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="奖励积分/标准积分"
          prop="jf"
          align="center"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          align="center"
          label="申请人"
          prop="sqr"
          min-width="100px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="协作开始时间"
          prop="xzksrq"
          align="center"
          min-width="120px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="协作结束时间"
          prop="xzjsrq"
          align="center"
          min-width="120px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="奖励状态"
          prop="jlType"
          align="center"
          min-width="120px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="奖励时间"
          prop="createTime"
          align="center"
          min-width="120px"
          :show-overflow-tooltip="true"
        />
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryParams.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryParams.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog
      title="任务奖励"
      :visible.sync="dialogFormVisible"
      width="960px"
      top="10px"
      custom-class="customClass"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <div class="lan">
        <span style="font-weight: bold; color: #000000">奖励积分</span>
        <span style="float: right; margin-right: 40px">
          奖励积分：
          <span style="font-weight: bold; color: #000000">{{ jf }}</span>
        </span>
      </div>
      <el-form :model="form">
        <div class="table2">
          <el-table
            style="width: 100%"
            :data="form.rlVoList"
            :show-header="false"
            :cell-style="cellStyle"
            :default-sort="{ prop: 'date', order: 'descending' }"
            tooltip-effect="dark"
          >
            <el-table-column
              property="xmJs"
              label="角色"
              width="170"
              align="center"
            ></el-table-column>
            <el-table-column label="成果物" width="200" align="left">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="cgw1(scope.row.ygbh)"
                  v-show="scope.row.js == 1"
                  >查看附件</el-button
                >
              </template>
            </el-table-column>
            <el-table-column width="120" align="center">积分</el-table-column>
            <el-table-column property="jf" label width="100">
              <template scope="scope">
                <el-input
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  :min="0"
                  maxlength="5"
                  v-model="scope.row.jf"
                  class="rule"
                ></el-input>
              </template>
            </el-table-column>

            <el-table-column width="170" align="center"
              >实际工作量（人日）</el-table-column
            >
            <el-table-column property="sjgzl" label width="100">
              <template scope="scope">
                <el-input
                  onkeyup="value=value.replace(/[^\d]/g,'')"
                  maxlength="5"
                  v-model="scope.row.sjgzl"
                  class="rule"
                ></el-input>
              </template>
            </el-table-column>

            <el-table-column width="100" align="center">
              <template slot-scope="scope">
                <el-button
                  style="
                    background: #8080ff;
                    border-color: #8080ff;
                    margin: auto;
                  "
                  @click="pinglun(scope.row)"
                  type="primary"
                  >+评论</el-button
                >
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="nodata">
                <img src="@/img/nodata.png" alt="" width="160" />
                <div>暂无数据</div>
              </div>
            </template>
          </el-table>
        </div>
      </el-form>
      <div class="lan">
        <span style="font-weight: bold; color: #000000">成果物审核</span>
      </div>

      <div style="padding-left: 25px; padding-right: 25px">
        <div style="margin-left: 800px">
          <el-button type="text" @click="cgwpz()">成果物批注意见</el-button>
        </div>
        <div style="margin-top: -20px">
          <el-tabs>
            <el-tab-pane
              v-for="(item, index) in cgw.reviewList"
              :label="'第' + (cgw.reviewList.length - index) + '轮评审'"
              :key="index"
            >
              <el-tabs type="card">
                <el-tab-pane
                  v-for="(it, i) in item.reviewList"
                  :label="
                    it.xm +
                    '/' +
                    (it.status === 1
                      ? '通过'
                      : it.status === 0
                      ? '不通过'
                      : '未审核')
                  "
                  :key="i"
                >
                  <el-card
                    class="box-card"
                    v-show="it.status !== 2"
                    shadow="hover"
                  >
                    <div slot="header" class="clearfix">
                      <span>{{ it.sj }}</span>
                    </div>
                    <div class="text item">{{ it.bz }}</div>
                  </el-card>
                  <!-- <div style="margin: 10px 0">
                <el-tag v-show="it.status !== 2">{{it.sj}}</el-tag>
                {{it.status !== 2? ( " " +it.bz) :""}}
                  </div>-->
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
          </el-tabs>
        </div>
        <!-- <div style="float: left">
          <div
            v-for="(item, index) in cgwRevieweList"
            :key="index"
            align="center"
            style="float: left; padding-top: 20px; margin-right: 20px"
          >
            <span>{{ item.updatetime }}</span>
            <br />
            <hr :ref="getclass(index)" color="#aaaaaa" size="0.5px" />
            <br />
            <br />
            <el-button @click="setbz(item.bz, getclass(index), index)" class="set-other-btn">
              {{ item.shr }}
              <span style="color: #8080ff">通过</span>
            </el-button>
          </div>
        </div>-->

        <!-- <el-input
          class="bz"
          type="textarea"
          :rows="10"
          readonly="true"
          maxlength="500"
          placeholder="审核备注"
          show-word-limit
          v-model="bz"
        ></el-input>-->
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit()">保 存</el-button>
        <el-button @click="color()">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="评论" :visible.sync="pinglundialogFormVisible">
      <el-input
        type="textarea"
        :rows="10"
        placeholder="请输入评论内容"
        maxlength="500"
        show-word-limit
        v-model="pinglu"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="pinglunConfirm()">确 定</el-button>
        <el-button @click="pinglundialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="成果物"
      :visible.sync="cgwdialogFormVisible"
      width="891px"
    >
      <el-table
        :data="cgwDetailList"
        v-loading="loading"
        fit
        :header-cell-style="tableHeaderColor"
        :max-height="height"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
        border
      >
        <el-table-column
          property="xm"
          label="上传人"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          property="uploadtime"
          label="上传时间"
          width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          property="filename"
          label="文件名"
          width="300"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="check(scope.row)">{{
              scope.row.filename
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          property="filesize"
          label="大小"
          width="200"
          align="center"
        ></el-table-column>
        <el-table-column property label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="download(scope.row)">下载</el-button>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
    </el-dialog>
  </div>
</template>
  
<script>
import {
  getRewardList,
  getselector,
  getRlDetail,
  insertReward,
  exportRewardList,
  updateReward,
  getcgwDetail,
} from "@/api/reward";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["cgw"]),
  },
  data() {
    return {
      pinglu: "",
      pinglundialogFormVisible: false,
      dialogFormVisible: false,
      cgwdialogFormVisible: false,
      height: 100,
      taskId: this.$route.params.taskId,
      queryParams: {
        rlrquery: [],
        xzrquery: [],
        taskId: this.$route.params.taskId,
        page: 1,
        pageSize: 10,
        type: 1,
      },
      rlrList: [],
      xzrList: [],
      loading: true,
      total: 0,
      reward: [],
      rlId: "",
      form: {
        rlVoList: [],
      },
      ygbh: "",
      jf: "",
      jlType: "",
      cgwDetailList: [],
      cgwpzList: [],
      cgwRevieweList: [],
      bz: "",
      hrStyle: {},
    };
  },
  created() {
    this.getlist();
    this.selector();
  },

  methods: {
    getlist() {
      getRewardList(this.queryParams).then((res) => {
        if (res.code == 0) {
          this.reward = res.data;
          this.total = res.count;
          this.loading = false;
          const docH = document.documentElement.clientHeight;
          const mycontainerH =
            document.querySelector(".mycontainer").clientHeight;
          this.height = docH - mycontainerH - 75;
        } else {
        }
      });
    },
    handleClick(tab, event) {
      this.getlist();
    },
    handleQuery() {
      this.getlist();
    },
    pinglunConfirm() {
      this.pinglundialogFormVisible = false;
      this.form.rlVoList.forEach((item) => {
        if (this.ygbh == item.ygbh) {
          item.pj = this.pinglu;
        }
      });
      this.pinglu = "";
    },
    handleUpdate(rlId) {
      this.rlId = rlId;
      this.dialogFormVisible = true;
      this.vLoading = true;
      getRlDetail(this.rlId, this.taskId).then((res) => {
        if (res.code == 0) {
          res.data.rlVoList.forEach((item) => {
            if (!item.sjgzl) {
              item.sjgzl = 0;
            }
          });
          this.form.rlVoList = res.data.rlVoList;
          this.jf = res.data.jf;
          this.jlType = res.data.jlType;
          this.cgwpzList = res.data.cgwpzList;
          this.cgwRevieweList = res.data.cgwRevieweList;
          this.vLoading = false;
        } else {
          this.vLoading = false;
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
      this.$store.dispatch("cgw/fetchCgwYtjListAction", {
        rlId: rlId,
      });
      this.$store.dispatch("cgw/fetchCgwPzYtjListAction", {
        rlId: rlId,
      });
      this.$store.dispatch("cgw/fetchCgwReviewAction", {
        rlId: rlId,
      });
    },
    pinglun(row) {
      this.pinglundialogFormVisible = true;
      this.ygbh = row.ygbh;
      if (row.pj) {
        this.pinglu = row.pj;
      }
    },
    handleExport() {
      exportRewardList(this.queryParams).then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    selector() {
      getselector(this.taskId).then((res) => {
        if (res.code == 0) {
          this.rlrList = res.data.rlrList;
          this.xzrList = res.data.xzrList;
        } else {
        }
      });
    },
    getclass(index) {
      return "hr_" + index;
    },
    submit() {
      this.form.rlVoList.forEach((item) => {
        item.rlId = this.rlId;
        item.taskId = this.taskId;
        // let that = this;
        // for (let i = 0; i < this.cgwRevieweList.length; i++) {
        //   let c = "hr_" + i;
        //   that.$refs[`${c}`][0].color = "#aaaaaa";
        // }
      });
      if (this.jlType) {
        updateReward(this.form.rlVoList).then((res) => {
          this.bz = "";
          if (res.code == 0) {
            this.dialogFormVisible = false;
            this.$message({
              message: "保存成功",
              type: "success",
            });
            this.getlist();
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        });
      } else {
        insertReward(this.form.rlVoList).then((res) => {
          if (res.code == 0) {
            this.dialogFormVisible = false;
            this.$message({
              message: "保存成功",
              type: "success",
            });
            this.getlist();
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        });
      }
    },
    color() {
      this.dialogFormVisible = false;
      this.bz = "";
      // let that = this;
      // for (let i = 0; i < this.cgwRevieweList.length; i++) {
      //   let c = "hr_" + i;
      //   that.$refs[`${c}`][0].color = "#aaaaaa";
      // }
    },
    cgwpz() {
      this.cgwdialogFormVisible = true;
      this.cgwDetailList = this.cgwpzList;
    },
    cgw1(ygbh) {
      this.cgwdialogFormVisible = true;
      this.loading = true;
      getcgwDetail(this.rlId, ygbh).then((res) => {
        if (res.code == 0) {
          this.cgwDetailList = res.data.cgwDetailList;
          this.loading = false;
        } else {
          this.$message({
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    // setbz(bz, a, x) {
    //   this.bz = bz;
    //   this.$refs[`${a}`][0].color = "#8080ff";
    //   const b = this.cgwRevieweList.length;
    //   let that = this;
    //   for (let i = 0; i < b; i++) {
    //     let c = "hr_" + i;
    //     if (i != x) {
    //       that.$refs[`${c}`][0].color = "#aaaaaa";
    //     }
    //   }
    // },
    handleClose(done) {
      done();
      this.bz = "";
      let that = this;
      // for (let i = 0; i < this.cgwRevieweList.length; i++) {
      //   let c = "hr_" + i;
      //   that.$refs[`${c}`][0].color = "#aaaaaa";
      // }
    },
    check(row) {
      const url = row.previewurl;
      window.open(url);
    },
    download(row) {
      const filePath = row.url;
      const fileName = row.filename;
      const url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;
      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getlist();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.getlist();
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 2 || columnIndex === 4 || columnIndex === 6) {
        //指定坐标rowIndex ：行，columnIndex ：列
        return "background:#8080ff;color:#FFFFFF;"; //rgb(105,0,7)
      } else {
        return "";
      }
    },
    toTaskList() {
      this.$router.push({
        name: "taskList",
      });
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
  },
};
</script>
  <style lang="less" scoped>
.app-container {
  padding: 10px;
  height: 100%;
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  padding-bottom: 0;
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
  box-sizing: border-box;
  padding-bottom: 0;
}
.filter-container {
  padding: 0;
}
.search-container {
  border: 0;
}
::v-deep #dic-form .el-form-item {
  margin-bottom: 0;
}
.el-form-item {
  margin-bottom: 22px;
}
.lan {
  background-color: #d7d7d7;
  height: 30px;
  padding-left: 25px;
  padding-top: 15px;
}
.rule /deep/ .el-input__inner {
  border: none;
}
.table2 /deep/ .el-input__inner {
  border: 10px;
}
.table2 /deep/ .el-table__row > td {
  padding: 0px 0;
}
/deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgb(255, 255, 255); //颜色必须是rgb
}
/deep/.customClass .el-dialog__body {
  padding: 10px 0px;
}
.set-other-btn:focus {
  border-color: #8080ff;
  background-color: #ffffff;
  color: #606266;
}
.bz {
  margin-top: 25px;
}
.myRadio {
  margin-right: 5px;
}
</style>
